<script>
import axios from 'axios';

export default class ClientPortalRepository {
    getHeaders() {
        const myClientUser = JSON.parse(window.localStorage.getItem("myClientUser") || "{}");
        return {
            'Authorization': `Bearer ${myClientUser.token}`,
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        };
    }

    async getHistorico() {
        const baseURL = process.env.VUE_APP_API_URL;
        return await axios.get(baseURL + 'cliente/historico', { headers: this.getHeaders() });
    }

    async getSolicitacoes() {
        const baseURL = process.env.VUE_APP_API_URL;
        return await axios.get(baseURL + 'cliente/solicitacoes', { headers: this.getHeaders() });
    }

    async createSolicitacao(data) {
        const baseURL = process.env.VUE_APP_API_URL;
        return await axios.post(baseURL + 'cliente/solicitacoes', data, { headers: this.getHeaders() });
    }
}
</script>
